/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConfirmBookingPlan,
    ConfirmBookingPlanFromJSON,
    ConfirmBookingPlanFromJSONTyped,
    ConfirmBookingPlanToJSON,
} from './ConfirmBookingPlan';

/**
 * 
 * @export
 * @interface ConfirmBookingPlanResponse
 */
export interface ConfirmBookingPlanResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof ConfirmBookingPlanResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof ConfirmBookingPlanResponse
     */
    message: string;
    /**
     * 
     * @type {ConfirmBookingPlan}
     * @memberof ConfirmBookingPlanResponse
     */
    data: ConfirmBookingPlan;
}

export function ConfirmBookingPlanResponseFromJSON(json: any): ConfirmBookingPlanResponse {
    return ConfirmBookingPlanResponseFromJSONTyped(json, false);
}

export function ConfirmBookingPlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmBookingPlanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ConfirmBookingPlanFromJSON(json['data']),
    };
}

export function ConfirmBookingPlanResponseToJSON(value?: ConfirmBookingPlanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ConfirmBookingPlanToJSON(value.data),
    };
}

